/**
 * Utility functions for theme management
 */

/**
 * Detect user's device color mode preference (light or dark)
 * @returns {string} 'light' or 'dark' based on device settings
 */
export const detectDeviceColorMode = () => {
  if (typeof window !== 'undefined') {
    // Check if user has a saved preference in localStorage
    const savedMode = localStorage.getItem('chakra-ui-color-mode');
    if (savedMode) {
      return savedMode;
    }

    // Check device preference using prefers-color-scheme media query
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
  }
  return 'light'; // Default fallback
};

/**
 * Setup listener for device color mode changes
 * Automatically updates when user changes their system preferences
 * @param {Function} callback - Function to call when color mode changes
 * @returns {Function} Cleanup function to remove the listener
 */
export const setupColorModeListener = (callback) => {
  if (typeof window !== 'undefined') {
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      const newMode = e.matches ? 'dark' : 'light';
      callback(newMode);
      localStorage.setItem('chakra-ui-color-mode', newMode);
    };

    // Modern browsers support addEventListener, older ones use addListener
    if (darkModeQuery.addEventListener) {
      darkModeQuery.addEventListener('change', handleChange);
      return () => darkModeQuery.removeEventListener('change', handleChange);
    } else if (darkModeQuery.addListener) {
      darkModeQuery.addListener(handleChange);
      return () => darkModeQuery.removeListener(handleChange);
    }
  }

  return () => {}; // No-op cleanup function
};
